import {ModuleRouteManifest} from '../types'

export const academicAdvisingRouteManifest: ModuleRouteManifest = {
  code: 'academic-advising',
  privateRoutes: ['my-consultant-students/*', 'student-consultant-follow-up/*'],
}
